import { type ReactNode } from 'react'

export interface PageConfig {
  title: string
  leftContent?: ReactNode
  actions?: ReactNode
}

export const PAGE_CONFIG: Record<string, PageConfig> = {
  '/insights': {
    title: 'Insights',
    leftContent: null,
    actions: null // Will be set dynamically with WeekNavigation
  },
  '/koba': {
    title: 'Koba AI Assistant', // This will be overridden by ChatHeaderContent
    leftContent: null,
    actions: null
  },
  '/planning': {
    title: 'Planning',
    leftContent: null,
    actions: null
  },
  '/life-domains': {
    title: 'Settings',
    leftContent: null,
    actions: null
  },
  '/settings': {
    title: 'Settings',
    leftContent: null,
    actions: null
  },
  '/integrations/tasks': {
    title: 'Integrations',
    leftContent: null,
    actions: null
  },
  '/integrations/calendars': {
    title: 'Integrations',
    leftContent: null,
    actions: null
  },
  '/automation-executions': {
    title: 'Rules execution',
    leftContent: null,
    actions: null
  }
}

export function getPageConfig(pathname: string): PageConfig {
  return PAGE_CONFIG[pathname] || {
    title: 'Page',
    leftContent: null,
    actions: null
  }
}
